import React from 'react'

type Props = {
  seconds: number
  renderCountdown: (str: string) => React.ReactNode
  renderElapsed?: () => React.ReactNode
}

const padDuration = (value: number) => value.toString().padStart(2, '0')

const Countdown = (props: Props) => {
  const { seconds, renderCountdown, renderElapsed } = props
  if (renderElapsed && !seconds) return renderElapsed() as JSX.Element
  const min = padDuration(Math.floor(seconds / 60))
  const sec = padDuration(seconds % 60)
  const str = `${min}:${sec}`
  return renderCountdown(str) as JSX.Element
}

export default Countdown
